export default __webpack_public_path__ + "static/bg-pttn-55e934297679907225b51f084e6814fc.png";